import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { polarisCollectionsRoute } from '@jira/router-routes__polaris-routes/src/polarisCollectionsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import CollectionsPage, { LazyCollectionsPage } from './ui/collections/index.tsx';

export const polarisCollectionsRouteEntry: Route = createEntry(polarisCollectionsRoute, () => ({
	isStrictModeEnabled: false,
	group: 'polaris',
	ufoName: 'jpd.collections',
	// eslint-disable-next-line no-restricted-syntax
	component: CollectionsPage,
	layout: globalLayout,

	canTransitionIn: () => {
		// default is no-refresh
		return true;
	},

	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
	],

	forPaint: [LazyAtlassianNavigation, LazyCollectionsPage],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
